import JSONAPIClient from '../JSONAPIClient'

JSONAPIClient.define('section_review', {
  status: '',
  task_item_id: '',
  section_id: '',
})
